// extracted by mini-css-extract-plugin
module.exports = {"searchIcon":"searchicon_searchIcon__yrvPw"};